import React from 'react';
import {Helmet} from 'react-helmet';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import Login from './Login';
import SetPassword from './SetPassword';
import Dashboard from './Dash';
import ReportDash from './report/ReportDash';
import ReportEdit from './report/ReportEdit';
import LookupMain from './lookup/Main';
import LookupContacts from './lookup/Contacts';
import ScheduleMain from './schedule/Main';
import QuotesMain from './quotes/Main';
import Map from './map/Map';
import OrdersMain from './orders/Main';
import AdminUsers from './admin/AdminUsers';
import Error from './Error';
import Loading from './Loading';

import HandleToken from './AuthService';

import Nav from './components/Nav.js';

import 'materialize-css';
import "@fontsource/roboto"; // Defaults to weight 400.
import { Button } from 'react-materialize';

import {bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import * as Actions from './redux/actions'; //Import your actions

import { PublicClientApplication } from '@azure/msal-browser';



const msalConfig = {
  auth: {
    clientId: 'f76ce1ea-1763-4dd0-b347-0025b2162386',
    redirectUri: 'http://localhost:3000',
  },
};

const msalInstance = new PublicClientApplication(msalConfig);

export const login = async () => {
  const loginRequest = {
    scopes: ['user.read', 'openid', 'profile'], // Define the required permissions
  };

  try {
    await msalInstance.loginPopup(loginRequest);
    // Handle successful login
  } catch (error) {
    // Handle login error
  }
};

export const logout = () => {
  msalInstance.logout();
};

class App extends React.Component {
  constructor() {
    super();

    this.state = {
      location: window.location.href,
      sessionPending: Boolean(localStorage.getItem('authToken'))
    };
  }

  componentDidMount() {
    let token = this.props.authToken;

    if (token) {
      const done = () => this.setState({sessionPending: false});
      this.props.refreshSession(token).then(done, done);
    }

    this.setState({location: window.location.pathname});
  }



  // route() {
  //   let loc = window.location.pathname;

  //   if (!this.props.authToken) {
  //     return <Login />
  //   }

  //   switch (loc) {
  //     case '/':
  //       return <ReportDash />
  //     case '/reports':
  //       return <ReportDash />
  //     case loc.match(/\/reports\/edit/)?.input:
  //       return <ReportEdit />
  //     case '/lookup':
  //       return <LookupMain />
  //     case '/schedule':
  //       return <ScheduleMain />
  //     default:
  //       // return <div>404</div>
  //       return <Dashboard />
  //   }
  // }

  render() {
    if (this.props.authToken && this.props.user?.tempPass) {
      return (
        <div>
          <Helmet>
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0-alpha.3/css/materialize.min.css" />
          </Helmet>
          <SetPassword />
          <Error error={this.props.error} acknowledge={() => this.props.clearError()} />
        </div>
      )
    }

    if (this.props.authToken && !this.props.user && this.state.sessionPending) {
      return <Loading loading={true} loadingMessage={this.props.loadingMessage} />
    }

    if (this.props.authToken && this.props.user?.operator) {
      return (
        <div>
          <Helmet>
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0-alpha.3/css/materialize.min.css" />
          </Helmet>
          <Nav location="reports">
            <Router>
              <Routes>
                <Route path="/reports/edit" element={<ReportEdit/>} />
                <Route path="*" element={<ReportDash/>} />
              </Routes>
            </Router>
          </Nav>
          <Error error={this.props.error} acknowledge={() => this.props.clearError()} />
        </div>
      )
    }

    if (this.props.authToken) {
      return (
        <div>
          <Helmet>
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0-alpha.3/css/materialize.min.css" />
          </Helmet>
          {/* {this.route()} */}
          <Nav location={window.location.pathname.split('/')[1] || 'lookup'}>
            <Router>
              <Routes>
                <Route path="/" element={<LookupMain/>} />
                <Route path="/reports" element={<ReportDash/>} />
                <Route path="/reports/edit" element={<ReportEdit/>} />
                <Route path="/lookup/contacts" element={<LookupContacts/>} />
                <Route path="/lookup" element={<LookupMain/>} />
                <Route path="/schedule" element={<ScheduleMain/>} />
                <Route path="/map" element={<Map/>} />
                <Route path="/orders" element={<OrdersMain/>} />
                <Route path="/quotes" element={<QuotesMain/>} />
                {this.props.user?.admin && <Route path="/admin" element={<AdminUsers/>} />}
                <Route path="/auth_token_redirect" component={<HandleToken/>} />
              </Routes>
            </Router>
          </Nav>
          <Error error={this.props.error} acknowledge={() => this.props.clearError()} />
        </div>
      )
    } else {
      return (
        <div>
          <Loading />
          <Helmet>
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/materialize/1.0.0-alpha.3/css/materialize.min.css" />
          </Helmet>
          <Login />
          <Error error={this.props.error} acknowledge={() => this.props.clearError()} />
        </div>
      )
    }

  }
}

function mapStateToProps(state, props) {
  return {
    // report: state.report,
    user: state.user,
    authToken: state.authToken,
    error: state.error,
    loading: state.loading,
    loadingMessage: state.loadingMessage
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
